// extracted by mini-css-extract-plugin
module.exports = {"list":"Notifications_list__WhgfS"};